import { Alert, Button, Link, Spinner } from '@apollo/orbit';
import React from 'react';

import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { DocsRouter } from 'src/lib/routers';

interface Props {
  graphId: string;
  operation: GraphQLTypes.OverrideButtonAffectedQueryFragment;
  loading: boolean;
  onUndoClick: () => void;
}

const MarkedAsSafeText = () => (
  <span>
    This operation change has been marked as{' '}
    <Link isExternal to={DocsRouter.path('SchemaOverridingFlaggedChanges')}>
      safe
    </Link>
    . Future schema checks won’t flag these exact changes again.
  </span>
);

const MarkedAsIgnoredText = () => (
  <span>
    This operation change has been{' '}
    <Link isExternal to={DocsRouter.path('SchemaOverridingFlaggedChanges')}>
      ignored
    </Link>
    . Future schema checks completely ignore the operation.
  </span>
);

export const MarkedAsSafeOrIgnoredAlert = ({
  graphId,
  operation,
  loading,
  onUndoClick,
}: Props) => (
  <Alert status="info" className="mb-4 overflow-visible">
    {operation.alreadyApproved && <MarkedAsSafeText />}
    {operation.alreadyIgnored && <MarkedAsIgnoredText />}
    <PermissionWarning
      graphId={graphId}
      graphPermissions="canWriteCheckConfiguration"
      childRenderer={(hasPermission) => {
        return (
          hasPermission && (
            <Button
              variant="buttonLink"
              className="ml-1"
              onClick={onUndoClick}
              rightIcon={loading ? <Spinner size="xs" /> : <></>}
            >
              Undo
            </Button>
          )
        );
      }}
    />
  </Alert>
);
